import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const testimonials = [
  {
    name: 'Michael Rodriguez',
    location: 'West Palm Beach, FL',
    service: 'Automotive Tinting',
    rating: 5,
    text: "Absolutely outstanding. The team tinted my BMW the same day I called — the finish is flawless, zero bubbles, and the heat difference inside the car is incredible. This is the only shop I'll ever use.",
    avatar: 'https://public.readdy.ai/ai/img_res/16b6578c4da94da7053af9c94c999aa2.jpg',
  },
  {
    name: 'Sarah Thompson',
    location: 'Jupiter, FL',
    service: 'Residential Film',
    rating: 5,
    text: "Our energy bills dropped noticeably the first month after installation. The house stays cooler, the glare is gone, and you can barely tell the film is there. Professional crew, clean job from start to finish.",
    avatar: 'https://readdy.ai/api/search-image?query=confident%20professional%20woman%20headshot%20portrait%20clean%20background%20business%20person%20smiling%20natural%20light&width=120&height=120&seq=av002&orientation=squarish',
  },
  {
    name: 'David Chen',
    location: 'Boca Raton, FL',
    service: 'Marine Tinting',
    rating: 5,
    text: "Had my 42-foot Sea Ray done and the result is exceptional. Glare on the water is gone, cabin stays cool, and the whole boat looks sharper. Worth every dollar — these guys really know their craft.",
    avatar: 'https://readdy.ai/api/search-image?query=confident%20professional%20asian%20man%20headshot%20portrait%20clean%20background%20business%20person%20smiling%20natural%20light&width=120&height=120&seq=av003&orientation=squarish',
  },
  {
    name: 'Jennifer Martinez',
    location: 'Palm City, FL',
    service: 'PPF + Ceramic',
    rating: 5,
    text: "I had PPF and ceramic coating done on my new Range Rover. The attention to detail is next level — no seams, no lifting, mirror-like finish. They take their time and do it right. Absolutely recommend.",
    avatar: 'https://readdy.ai/api/search-image?query=confident%20professional%20latina%20woman%20headshot%20portrait%20clean%20background%20business%20person%20smiling%20natural%20light&width=120&height=120&seq=av004&orientation=squarish',
  },
];

export function Testimonials() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="testimonials" className="py-28 bg-[#0D0D0D] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] rounded-full bg-[#FF6B35]/5 blur-[140px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10" ref={ref}>
        {/* Header + rating badge side by side */}
        <div
          className={`anim-hidden ${isVisible ? 'animate-fade-in-up' : ''} flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 mb-16`}
        >
          <div>
            <span className="luxury-divider" />
            <span className="text-xs font-bold uppercase tracking-[5px] text-[#C9A96E] mb-4 block">
              Client Stories
            </span>
            <h2
              className="text-4xl sm:text-5xl font-bold text-white leading-tight tracking-tight"
              style={{ fontFamily: 'Sora, sans-serif' }}
            >
              Real Results.
              <br />
              <span className="shimmer-gold">Real Reviews.</span>
            </h2>
          </div>
          {/* Google rating block */}
          <div className="bg-white/[0.04] border border-[#C9A96E]/20 rounded-2xl px-8 py-6 text-center min-w-[200px]">
            <div className="flex justify-center gap-0.5 mb-2">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#C9A96E] text-xl" />
              ))}
            </div>
            <div className="text-4xl font-bold text-white mb-1" style={{ fontFamily: 'Sora, sans-serif' }}>
              5.0
            </div>
            <div className="text-xs text-white/40 uppercase tracking-widest">Google Rating</div>
            <div className="text-xs text-white/30 mt-1">500+ reviews</div>
          </div>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className={`anim-hidden ${isVisible ? `animate-fade-in-up delay-${(i + 1) * 100}` : ''} bg-white/[0.04] border border-white/8 hover:border-[#C9A96E]/30 rounded-2xl p-8 transition-all duration-300 cursor-default`}
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-5">
                {[...Array(t.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#C9A96E] text-sm" />
                ))}
              </div>
              {/* Quote */}
              <p className="text-white/75 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              {/* Author */}
              <div className="flex items-center gap-4 pt-4 border-t border-white/8">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 border-2 border-[#FF6B35]/30">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-white text-sm font-bold" style={{ fontFamily: 'Sora, sans-serif' }}>
                    {t.name}
                  </div>
                  <div className="text-white/40 text-xs">{t.location}</div>
                </div>
                <div className="ml-auto">
                  <span className="bg-[#FF6B35]/15 text-[#FF6B35] text-xs px-3 py-1 rounded-full font-medium">
                    {t.service}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA strip */}
        <div
          className={`anim-hidden ${isVisible ? 'animate-fade-in-up delay-500' : ''} mt-14 text-center`}
        >
          <p className="text-white/40 text-sm mb-4">
            Join 500+ satisfied customers across Martin &amp; Palm Beach County
          </p>
          <a
            href="#quote"
            className="inline-flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E55A2B] text-white px-8 py-4 rounded-full text-sm font-bold transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Be Our Next Success Story <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
